export const data = {
  logbookName: "Test Spec 1",
  logbookVersion: "1.0.0",
  primaryVerifiers: [],
  secondaryVerifiers: [],
  regulatory: 0,
  author: "",
  features: {
    panel: {
      align: "left",
    },
  },
  content: [
    {
      group: "ENG",
      layout: "vertical",
      panel: "ID1",
      content: [
        {
          group: "ENG_PORT",
          layout: "vertical",
          panel: "ID2",
          inherited: {
            label: {
              orientation: "left",
              textAlign: "center",
              width: "35%",
            },
            unit: {
              unitWidth: "64px",
              unitStyle: "inset-solid",
            },
          },
          content: [
            {
              group: "ENG",
              layout: "horizontal",
              panel: "ID1",
              inherited: {
                label: {
                  orientation: "left",
                  textAlign: "center",
                  width: "35%",
                },
                unit: {
                  width: "64px",
                  style: "inset-solid",
                },
              },
              label: {
                text: "X [mt] = Y [m3] x Z [mt/m3]",
                bold: true,
              },
              content: [
                {
                  item: "i1",
                  component: "text",
                  unit: {
                    text: "m3",
                  },
                },
                {
                  item: "i2",
                  component: "text",
                  unit: {
                    text: "mt/m3",
                  },
                },
                {
                  item: "i2",
                  component: "text",
                  label: {
                    text: "Total",
                    bold: true,
                  },
                  unit: {
                    text: "mt",
                  },
                },
              ],
            },
          ],
        },
        {
          group: "ENG_PORT",
          layout: "vertical",
          marginTop: "32px",
          panel: "ID2",
          inherited: {
            label: {
              orientation: "left",
              textAlign: "center",
              width: "35%",
            },
            unit: {
              width: "64px",
              style: "inset-solid",
            },
          },
          content: [
            {
              group: "ENG",
              layout: "horizontal",
              panel: "ID1",
              label: {
                text: "X [mt] = Y [m3] x ( Z / 1000 [kg/m3] )",
                bold: true,
              },
              inherited: {
                label: {
                  orientation: "left",
                  textAlign: "center",
                  width: "35%",
                },
                unit: {
                  width: "64px",
                  style: "inset-solid",
                },
              },
              content: [
                {
                  item: "i1",
                  component: "text",
                  unit: {
                    text: "m3",
                  },
                },
                {
                  item: "i2",
                  component: "text",
                  unit: {
                    text: "kg/m3",
                  },
                },
                {
                  item: "i2",
                  component: "text",
                  label: {
                    text: "Total",
                    bold: true,
                  },
                  unit: {
                    text: "mt",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
